(function () {
	'use strict';

	angular
		.module('core.services')
		.service('ParameterService', ParameterService)

	/** @ngInject */
	function ParameterService(HttpService) {
		const ParameterService = {
			getAll,
			getPaymentMethods,
			getByParameters,
			post,
			postPaymentMethods,
			put,
			deleteData
		}

		return ParameterService;

		function getAll() {
			return HttpService.get('/parameters/by-parameters', {
				params: {}
			});
		}

		function getPaymentMethods() {
			return HttpService.get('/parameters/payment-methods');
		}

		function getByParameters(params) {
			return HttpService.get('/parameters/by-parameters', {
				params
			});
		}

		function post(companyParameterData) {
			return HttpService.post('/parameters', companyParameterData);
		}

		function postPaymentMethods(companyPaymentMethodsData, companyId) {
			return HttpService.post(`/companies/${companyId}/parameters/payment-methods`, companyPaymentMethodsData);
		}

		function put(companyParameterData) {
			return HttpService.put('/parameters', companyParameterData);
		}

		function deleteData(companyParameterId) {
			return HttpService.delete(`/parameters/${companyParameterId}`);
		}
	}
}());